import { JetView } from "webix-jet";

export default class EditorView extends JetView {
	config() {
		const _ = this.app.getService("locale")._;

		let options = [
			{ id: "users.form", value: _("General") },
			{ id: "users.rules", value: _("Rules") },
			{ id: "users.audit", value: _("Audit") },
		];
		// The last should be Audit panel
		if (this.app.config.roles)
			options.splice(2, 0, { id: "users.roles", value: _("Roles") });

		const tabbar = {
			view: "tabbar",
			localId: "tabbar",
			css: "webix_um_editor_tabbar",
			height: webix.skin.$active.barHeight - 2,
			type: "bottom",
			options: options,
			borderless: true,
			on: {
				onChange: v => this.SetMode(v),
			},
		};

		const toolbar = {
			view: "toolbar",
			padding: {
				left: 2,
				right: 0,
				top: 0,
				bottom: 0,
			},
			cols: [
				{
					view: "icon",
					icon: "umi-back",
					click: () =>
						this.app.callEvent("details.back:click", [
							"users",
							this.getParam("id", true),
						]),
				},
				tabbar,
			],
		};

		return {
			rows: [toolbar, { $subview: true }],
		};
	}

	init() {
		if (this.getUrl().length < 2) this.show("./users.form");
		else this.$$("tabbar").setValue(this.getUrl()[1].page);
	}
	SetMode(v) {
		this.show(v);
	}
}
